import React from "react";
import { Timezone } from "@linkfluence/models/timezone";
import TopAuthors from "@radarly/components/widgets/top-authors";
import { useTopAuthorsWidget } from "@radarly/core/widgets/use-cases";
import { DatavizTopAuthors } from "@radarly/models/dataviz";
import { SearchableInfluencer } from "@radarly/models/influencer";
import { SearchFragmentUsers } from "@radarly/models/search";
import Empty from "../../empty";
import Loading from "../../loading";
import Tooltip from "../../tooltip/influencer";
export interface SharedWidgetsAuthorsTopAuthorsProps {
  project: number;
  dataviz: DatavizTopAuthors;
  fragment: SearchFragmentUsers;
  onClickInfluencer?: (influencer: SearchableInfluencer) => void;
  className?: string;
  sortable?: boolean;
  forceReload?: boolean;
  isFullscreen?: boolean;
  timezone: Timezone;
  closeFullscreen?: () => void;
}

export default function SharedWidgetsAuthorsTopAuthors({
  fragment,
  project,
  sortable,
  forceReload,
  isFullscreen,
  closeFullscreen,
  onClickInfluencer,
  timezone,
  ...props
}: SharedWidgetsAuthorsTopAuthorsProps) {
  const { data, loading, sort, setSort, isEmpty, locale } = useTopAuthorsWidget(
    project,
    fragment,
    !sortable
  );
  const _onClickInfluencer = (influencer: SearchableInfluencer) => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClickInfluencer(influencer);
  };
  return (
    <Loading loading={loading} forceReload={forceReload}>
      <Empty empty={isEmpty}>
        <TopAuthors
          influencers={data ? data.aggs.users.values : []}
          sort={sort}
          onSort={setSort}
          locale={locale}
          isFullscreen={isFullscreen}
          onClickInfluencer={onClickInfluencer && _onClickInfluencer}
          tooltip={(influencer: SearchableInfluencer) => (
            <Tooltip
              influencer={influencer}
              locale={locale}
              timezone={timezone}
              fragment={fragment}
            />
          )}
          {...props}
        />
      </Empty>
    </Loading>
  );
}
